// Turn a product id into a deterministic-but-varied sway rhythm so each
// freshener on the page swings at its own pace (no lockstep). Same product
// always gets the same rhythm across renders → no jank on re-render.
function hashCode(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function swayStyleFor(seed) {
  const h = hashCode(String(seed || "bb"));
  // duration 4.4s .. 7.6s (spread of ~3.2s so lockstep is impossible)
  const duration = 4.4 + ((h % 320) / 100);
  // delay 0 .. -3.6s (negative pushes the start into the middle of the cycle)
  const delay = -((h >> 5) % 360) / 100;
  // amplitude 2.5° .. 4.5°
  const amp = 2.5 + ((h >> 11) % 200) / 100;
  return {
    "--sway-duration": `${duration.toFixed(2)}s`,
    "--sway-delay": `${delay.toFixed(2)}s`,
    "--sway-amp": `${amp.toFixed(2)}deg`,
  };
}
